import React from 'react';
import classNames from 'classnames';

export default class GridCol extends React.Component {
  constructor() {
    super();
  }

  render() {
    const { desktop, mobile, tablet, tabletLg, className, children, hasBorder, height } = this.props;
    const gridColClasses = classNames('cell', {
      [`cell-desktop_${desktop}`]: desktop,
      [`cell-mobile_${mobile}`]: mobile,
      [`cell-tablet_${tablet}`]: tablet,
      [`cell-tabletLg_${tabletLg}`]: tabletLg,
      [`cell-height_${height}`]: height,
      'cell_hasBorder': hasBorder
    }, className);

    return (
      <div className={gridColClasses}>
        {children}
      </div>
    );
  }
}

GridCol.defaultProps = {
  'desktop': 12,
  'mobile': 4,
  'tablet': 8,
  'tabletLg': 8,
}



// WEBPACK FOOTER //
// ./src/client/components/grid/grid-col.jsx